import React from 'react';
import styles from './index.module.scss';

const ToolSectionTitle = ({ label }) => (
    <h3 className={styles.toolSectionTitle}>{label}</h3>
);

export default ToolSectionTitle;